export default "__VITE_ASSET__BpPrUguP__"